export default __webpack_public_path__ + "static/dla-poczatkujacych-icon-53d4eeeeb64b1cc35186b4da910b2169.svg";